import { colors, devices, font } from '../../config/theme'

const style = {}

style.base = {
  height: '100%'
}

style.upcomingVisitSmall = {
  color: colors.blue
}

style.existingApptNote = {
  fontSize: '15px !important',
  lineHeight: '19px !important',
  color: colors.black,
  marginBottom: '5px',
  fontWeight: font.weights.medium
}

style.base[devices.desktop] = {}
style.base[devices.mobile] = {
  '& .schedule-note': {
    fontSize: '16px !important'
  }
}

export default style
